import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button, Typography, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import history from '../../history';

const useStyles = makeStyles(theme => ({
    dialogActions: {
		justifyContent: 'center',
	},
	dialogButton: {
		minWidth: '100px',
	},
	dialogContent: {
		paddingBottom: '20px',
	},
	mainDialog: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
		textAlign: 'center',
	},
}));


const ConfirmDeleteDialog = props => {
  const { open, onClose, onConfirm } = props;

  const classes = useStyles();

  return (

      <Dialog
        open={open}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="confirmation-dialog-title"
        fullWidth={true}
        maxWidth="sm"
        classes={{
            paper: classes.mainDialog,
        }}
        >
            <DialogContent classes={{ root: classes.dialogContent}}> <Typography component="h5"
                variant="h5"> Are you sure that you want to delete this record? If yes, system will automatically delete all sub records (suite, events etc). </Typography></DialogContent>
            <DialogActions className={classes.dialogActions}>
                
                <Button onClick={onConfirm} color="primary" variant="contained" className={classes.dialogButton}>
                    Yes
                </Button>
                <Button autoFocus onClick={onClose} color="primary" variant="contained" className={classes.dialogButton}>
                    No
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ConfirmDeleteDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
};
  
ConfirmDeleteDialog.defaultProps = {
    onClose: () => {},
    onConfirm: () => {},
    open: false
};
  
export default ConfirmDeleteDialog;